import './UpdateProject.css'

import { projectStatusOptions } from '../../utilities/services/projectsOptions';
import { useEffect, useState } from 'react';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { updateProject } from '../../utilities/api/projectsTimeline';


export default function UpdateProject({user, users, projectItem, updateProjects, toggleNotifications}) {
  const [activeUsers, setActiveUsers] = useState([])
  const defaultState = {
    userID: user._id,
    assignedAnalystId: projectItem.assignedAnalystId,
    managerID: projectItem.managerID,
    contractStatus: projectItem.contractStatus,
    contractURL: projectItem.contractURL,
    ndaStatus: projectItem.ndaStatus,
    ndaURL: projectItem.ndaURL,
    dueDate: projectItem.dueDate,
    clientNumber: projectItem.clientNumber? projectItem.clientNumber: '',
    clientDeadline: projectItem.clientDeadline,
    firstInvoiceStatus: projectItem.firstInvoiceStatus,
    firstInvoiceURL: projectItem.firstInvoiceURL,
    // firstPaymentStatus: projectItem.firstPaymentStatus,
    projectStatus: projectItem.projectStatus,
    projectReportStatus: projectItem.projectReportStatus,
    formURL: projectItem.formURL,
    projectReportURL: projectItem.projectReportURL,
    // searchPaymentStatus: projectItem.searchPaymentStatus,
    secondInvoiceStatus: projectItem.secondInvoiceStatus,
    secondInvoiceURL: projectItem.secondInvoiceURL,
    // secondPaymentStatus: projectItem.secondPaymentStatus,
    otherURL1: projectItem.otherURL1,
    otherURL2: projectItem.otherURL2,
    otherURL3: projectItem.otherURL3,
    otherURL4: projectItem.otherURL4,
  }
  // console.log(defaultState)
  const [formData, setFormData] = useState(defaultState)

  const handleSubmit = async (evt) =>{
      evt.preventDefault();
      // console.log(formData)
      try{
        const data = {...formData}
        const updatedProjects = await updateProject(projectItem._id, data)
        await updateProjects(updatedProjects)
        await toggleNotifications('success', `Project "${capitalizeFirstLetter(projectItem.projNum)}" Updated!`, '#FFFFFF')
      }catch (err) {
        await toggleNotifications('error', `Failed to Update Project "${capitalizeFirstLetter(projectItem.projNum)}"!`, '#FFFFFF')
        console.log(err)
      }
  }

  function handleChange(evt) {
    const newFormData = {
      ...formData,
      [evt.target.name]: evt.target.value,
    };
    setFormData(newFormData);
  }

  useEffect(() => {
    setActiveUsers(users.filter(user => user.status === 'active'))
    // eslint-disable-next-line
  }, [users])

  return (
    <div className='UpdateProject modal fade' id={`updateProjectModal${projectItem._id}`}  data-bs-keyboard="true">
      <div className="modal-dialog">
        <div className="modal-content formContainer">
          <div className='header'>
            <div className='left'>
              <div className='first'>
                <svg width="25" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                  <path d="M8.75 2.625H2.625V8.75H8.75V2.625Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M18.375 2.625H12.25V8.75H18.375V2.625Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M18.375 12.25H12.25V18.375H18.375V12.25Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8.75 12.25H2.625V18.375H8.75V12.25Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div className='second'>
                <div className='sec1'>
                  Update 
                  <span className='primaryText ps-1'>{capitalizeFirstLetter(projectItem.projNum)}</span>
                </div>
              </div>
            </div>
            <div className='right'>
              <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
          <form onSubmit={handleSubmit} id={`updateProjectForm${projectItem._id}`}>
            <div className='formContent'>
              { !(projectItem.clientID) &&
              <div className='form-group'>
                <label htmlFor={`clientNumber${projectItem._id}`} className='form-label'>Client Number</label>
                <input type="number" min={1} id={`clientNumber${projectItem._id}`} name='clientNumber' className='form-control' defaultValue={formData.clientNumber} placeholder='Add client number' onChange={handleChange}/>
              </div>
              }
              <div className='form-group'>
                <label htmlFor={`manager${projectItem._id}`} className='form-label'>Manager</label>
                { activeUsers.length !== 0 &&
                <select id={`manager${projectItem._id}`} name='managerID' className='form-select' defaultValue={formData.managerID} onChange={handleChange}>
                  <option value="" disabled>---</option>
                  { activeUsers.map((user, index) => (
                      <option key={index} value={user._id}>{capitalizeFirstLetter(user.firstName)} {capitalizeFirstLetter(user.lastName)}</option>
                  ))}
                </select>
                }
              </div>
              <div className='form-group'>
                <label htmlFor={`assignee${projectItem._id}`} className='form-label'>Analyst</label>
                { activeUsers.length !== 0 &&
                <select id={`assignee${projectItem._id}`} name='assignedAnalystId' className='form-select' defaultValue={formData.assignedAnalystId} onChange={handleChange}>
                  <option value="" disabled>---</option>
                  { activeUsers.map((user, index) => (
                      <option key={index} value={user._id}>{capitalizeFirstLetter(user.firstName)} {capitalizeFirstLetter(user.lastName)}</option>
                  ))}
                </select>
                }
              </div>
              {/* { !['IPGAPS', 'FTOA'].includes(projectItem.projType) && */}
              <div className='form-group'>
                <label htmlFor={`projectStatus${projectItem._id}`} className='form-label'>Project</label>
                <select id={`projectStatus${projectItem._id}`} name='projectStatus' className={`form-select status ${formData.projectStatus}`} defaultValue={formData.projectStatus} onChange={handleChange}>
                    <option value="" disabled>---</option>
                    { projectStatusOptions.map((projectStatus, index) => (
                        <option key={index} value={projectStatus.value}>{capitalizeFirstLetter(projectStatus.name)}</option>
                    ))}
                </select>
              </div>
              {/* } */}
              <div className='form-group'>
                <label htmlFor={`contractStatus${projectItem._id}`} className='form-label'>Contract</label>
                <select id={`contractStatus${projectItem._id}`} name='contractStatus' className={`form-select status ${formData.contractStatus}`} defaultValue={formData.contractStatus} onChange={handleChange}>
                    <option value="complete">Complete</option>
                    <option value="incomplete">Incomplete</option>
                </select>
              </div>
              <div className='form-group'>
                <label htmlFor={`ndaStatus${projectItem._id}`} className='form-label'>NDA</label>
                <select id={`ndaStatus${projectItem._id}`} name='ndaStatus' className={`form-select status ${formData.ndaStatus}`} defaultValue={formData.ndaStatus} onChange={handleChange}>
                    <option value="na">N/A</option>
                    <option value="complete">Complete</option>
                    <option value="incomplete">Incomplete</option>
                    
                </select>
              </div>
              <div className='form-group'>
                <label htmlFor={`dueDate${projectItem._id}`} className='form-label'>Analyst Deadline</label>
                <input type="date" id={`dueDate${projectItem._id}`} name='dueDate' className='form-control' defaultValue={formData.dueDate} onChange={handleChange}/>
              </div>
              <div className='form-group'>
                <label htmlFor={`clientDeadline${projectItem._id}`} className='form-label'>Client Deadline</label>
                <input type="date" id={`clientDeadline${projectItem._id}`} name='clientDeadline' className='form-control' defaultValue={formData.clientDeadline} onChange={handleChange}/>
              </div>
              <div className='form-group'>
                <label htmlFor={`firstInvoiceStatus${projectItem._id}`} className='form-label'>First Invoice</label>
                <select id={`firstInvoiceStatus${projectItem._id}`} name='firstInvoiceStatus' className={`form-select status ${formData.firstInvoiceStatus}`} defaultValue={formData.firstInvoiceStatus} onChange={handleChange}>
                    <option value="na">N/A</option>
                    <option value="pending">Pending</option>
                    <option value="sent">Sent</option>
                    <option value="paid">Paid</option>
                </select>
              </div>
              <div className='form-group'>
                <label htmlFor={`projectReportStatus${projectItem._id}`}> Project Report</label>
                <select id={`projectReportStatus${projectItem._id}`} name='projectReportStatus' className={`form-select status ${formData.projectReportStatus}`} defaultValue={formData.projectReportStatus} onChange={handleChange}>
                    <option value="generated">Generated</option>
                    <option value="pending">Pending</option>
                    <option value="na">N/A</option>
                </select>
              </div>
              <div className='form-group'>
                <label htmlFor={`secondInvoiceStatus${projectItem._id}`} className='form-label'>Second Invoice</label>
                <select id={`secondInvoiceStatus${projectItem._id}`} name='secondInvoiceStatus'  className={`form-select status ${formData.secondInvoiceStatus}`} defaultValue={formData.secondInvoiceStatus} onChange={handleChange}>
                    <option value="na">N/A</option>
                    <option value="pending">Pending</option>
                    <option value="sent">Sent</option>
                    <option value="paid">Paid</option>
                </select>
              </div>
              <div className='linksContainer'>
                <div className='linksHeader'>Useful Links</div>
                <div className='form-group'>
                  <label htmlFor={`contractURL${projectItem._id}`} className='form-label'>Contract</label>
                  <input type="text" id={`contractURL${projectItem._id}`} name='contractURL' className='form-control' defaultValue={formData.contractURL} placeholder='Add link here' onChange={handleChange}/>
                </div>
                <div className='form-group'>
                  <label htmlFor={`ndaURL${projectItem._id}`} className='form-label'>NDA</label>
                  <input type="text" id={`ndaURL${projectItem._id}`} name='ndaURL' className='form-control' defaultValue={formData.ndaURL} placeholder='Add link here' onChange={handleChange}/>
                </div>
                <div className='form-group'>
                  <label htmlFor={`formURL${projectItem._id}`} className='form-label'>Form</label>
                  <input type="text" id={`formURL${projectItem._id}`} name='formURL' className='form-control' defaultValue={formData.formURL} placeholder='Add link here' onChange={handleChange}/>
                </div>
                <div className='form-group'>
                  <label htmlFor={`firstInvoiceURL${projectItem._id}`} className='form-label'>First Invoice</label>
                  <input type="text" id={`firstInvoiceURL${projectItem._id}`} name='firstInvoiceURL' className='form-control' defaultValue={formData.firstInvoiceURL} placeholder='Add link here' onChange={handleChange}/>
                </div>
                <div className='form-group'>
                  <label htmlFor={`secondInvoiceURL${projectItem._id}`} className='form-label'>Second Invoice</label>
                  <input type="text" id={`secondInvoiceURL${projectItem._id}`} name='secondInvoiceURL' className='form-control' defaultValue={formData.secondInvoiceURL} placeholder='Add link here' onChange={handleChange}/>
                </div>
                <div className='form-group'>
                  <label htmlFor={`projectReportURL${projectItem._id}`} className='form-label'>Project Report</label>
                  <input type="text" id={`projectReportURL${projectItem._id}`} name='projectReportURL' className='form-control' defaultValue={formData.projectReportURL} placeholder='Add link here' onChange={handleChange}/>
                </div>
                <div className='form-group'>
                  <label htmlFor={`otherURL1${projectItem._id}`} className='form-label'>Other Link 1</label>
                  <input type="text" id={`otherURL1${projectItem._id}`} name='otherURL1' className='form-control' defaultValue={formData.otherURL1} placeholder='Add link here' onChange={handleChange}/>
                </div>
                <div className='form-group'>
                  <label htmlFor={`otherURL2${projectItem._id}`} className='form-label'>Other Link 2</label>
                  <input type="text" id={`otherURL2${projectItem._id}`} name='otherURL2' className='form-control' defaultValue={formData.otherURL2} placeholder='Add link here' onChange={handleChange}/>
                </div>
                <div className='form-group'>
                  <label htmlFor={`otherURL3${projectItem._id}`} className='form-label'>Other Link 3</label>
                  <input type="text" id={`otherURL3${projectItem._id}`} name='otherURL3' className='form-control' defaultValue={formData.otherURL3} placeholder='Add link here' onChange={handleChange}/>
                </div>
                <div className='form-group'>
                  <label htmlFor={`otherURL4${projectItem._id}`} className='form-label'>Other Link 4</label>
                  <input type="text" id={`otherURL4${projectItem._id}`} name='otherURL4' className='form-control' defaultValue={formData.otherURL4} placeholder='Add link here' onChange={handleChange}/>
                </div>
              </div>
            </div>
          </form>
          <div className='d-flex justify-content-center formButtonContainer'>
            <button data-bs-dismiss="modal" className='cancel'>Cancel</button>
            <button data-bs-dismiss="modal" className="primary submit" type="submit" form={`updateProjectForm${projectItem._id}`}>Save Changes</button>
          </div>
        </div>
      </div>
    </div>
  )
}
